import React, { Suspense, useState } from 'react';
import Icona from '../Icone';
import { datiImmobile, pilloleDintorni, vociDintorni } from '../../../utils/immobili';
import { useTraduzioni } from '../../../i18n';
import './dati-immobile.css';

// Un dato della casa (m², locali, bagni, piano, ascensore, classe, spese, anno, stato, riscaldamento): piccolo
// badge con l'icona a linea e il valore. Si usa nell'elenco (i primi 4), nelle schede cliente e staff e nel
// confronto. Se il dato manca, niente badge.

const MiniMappa = React.lazy(() => import('./MiniMappa'));

export const DatoImmobile = ({ dato }) => (
  <span className="dato-imm" data-dato={dato.chiave}>
    <Icona nome={dato.icona} className="" />
    {dato.prima && dato.etichetta ? <><span>{dato.etichetta}</span><b>{dato.valore}</b></> : <><b>{dato.valore}</b>{dato.etichetta && <span>{dato.etichetta}</span>}</>}
  </span>
);

export const DatiImmobile = ({ immobile, quanti, piccoli = false }) => {
  const { l } = useTraduzioni();
  const dati = datiImmobile(immobile, l).slice(0, quanti || undefined);
  if (!dati.length) return null;
  return <div className={`dati-imm${piccoli ? ' piccoli' : ''}`}>{dati.map((d) => <DatoImmobile key={d.chiave} dato={d} />)}</div>;
};

// Pillole dei dintorni (trasporti prima): nell'elenco solo da leggere, nelle schede aprono il dettaglio
export const PilloleDintorni = ({ immobile, quante = 4, onApri, aperto = false }) => {
  const { t, l } = useTraduzioni();
  const pillole = onApri ? vociDintorni(immobile, l) : pilloleDintorni(immobile, quante, l);
  if (!pillole.length) return null;
  const Pillola = onApri ? 'button' : 'span';
  return (
    <div className="pillole-dint" aria-label={t('immobili.dintorni.titolo')} data-testid="pillole-dintorni">
      {pillole.map((p) => (
        <Pillola key={p.chiave} {...(onApri ? { type: 'button', onClick: onApri, 'aria-expanded': aperto, title: t('immobili.dintorni.a_piedi', { nome: p.nome || p.titolo, n: p.minuti }) } : {})}>
          <Icona nome={p.icona} className="" /><b>{t('immobili.dintorni.minuti', { n: p.minuti })}</b>{!onApri && p.nome && <span className="nome">{p.nome}</span>}
        </Pillola>
      ))}
    </div>
  );
};

export const DettaglioDintorni = ({ immobile }) => {
  const { t, l } = useTraduzioni();
  const voci = vociDintorni(immobile, l);
  const lat = immobile.dintorni?.lat ?? immobile.latitudine;
  const lon = immobile.dintorni?.lon ?? immobile.longitudine;
  return (
    <div className="dett-dint" data-testid="dettaglio-dintorni">
      <ul>
        {voci.map((v) => (
          <li key={v.chiave}>
            <Icona nome={v.icona} className="" />
            <div><b>{v.nome}</b><small>{v.dettaglio || v.titolo || ''}</small></div>
            <span className="min">{t('immobili.dintorni.minuti', { n: v.minuti })}</span>
          </li>
        ))}
      </ul>
      {lat != null && lon != null && (
        <div className="mini-mappa">
          <Suspense fallback={null}><MiniMappa lat={lat} lon={lon} voci={voci} /></Suspense>
        </div>
      )}
      <p className="fonte">{t('immobili.dintorni.fonte')}</p>
    </div>
  );
};

// Pillole + dettaglio che si apre sotto (scheda del cliente e dello staff)
export const Dintorni = ({ immobile, className = '' }) => {
  const { l } = useTraduzioni();
  const [aperto, setAperto] = useState(false);
  if (!vociDintorni(immobile, l).length) return null;
  return (
    <div className={className}>
      <PilloleDintorni immobile={immobile} onApri={() => setAperto(!aperto)} aperto={aperto} />
      {aperto && <DettaglioDintorni immobile={immobile} />}
    </div>
  );
};

export default DatoImmobile;
